module.exports = __webpack_public_path__ + "static/team-ie-5a2174947c3f990a7b7928b45b2c7878.png";